import * as React from "react"

import "./index.scss"

export interface BadgeProps {
	text: string
	color: "blue" | "green"
}

const Badge: React.FC<BadgeProps> = ({ text, color }): JSX.Element => (
	<div>
		<span className={`badge badge-${color}`}>{text}</span>
	</div>
)

export default Badge
